import "./contact.css";
import { Contact } from "./Contact";
export default Contact;